// Set up Mobile Menu Interactions
const mobileNavInit = () => {
    // the icon switch-aroo
    const $icons = $('.header-wrapper .icon-menu');

    const openMenu = () => {
        $icons.toggleClass('active');
        $('.menu-primary-menu-container').height('100%').addClass('active');
        $('#icon-menu-open').attr('aria-expanded', 'true');
    };

    const closeMenu = () => {
        $icons.toggleClass('active');
        $('.menu-primary-menu-container').height('initial').removeClass('active');
        $('#icon-menu-open').attr('aria-expanded', 'false');
    };

    const mobileNavToggle = () => {
        if ($('.menu-primary-menu-container').height() === 0) {
            openMenu();
        } else {
            closeMenu();
        }
    };

    /* ----------  Bind Events  ----------*/
    $icons.on('click', () => {
        mobileNavToggle();
    });

    // open menu by pressing return
    $icons.keydown((event) => {
        if (event.keyCode === 13) {
            mobileNavToggle();
        }
    });

    // close mobile nav by pressing escape
    $(document).keyup((event) => {
        if (event.keyCode === 27 && $('.menu-primary-menu-container').height() > 0) {
            closeMenu();
        }
    });
};

jQuery(document).ready(() => {
    mobileNavInit();
});
